import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { deeperResearchClient } from '#pplx_generated/typespec/rest/deeper_research/client.js';
export const getAssetDownloadURL = async ({ request, reason, signal, }) => {
    const { data, error, response } = await deeperResearchClient.POST('/rest/deeper-research/download-asset', reason, {
        body: request,
        timeoutMs: 10000,
        numRetries: 2,
        signal,
    });
    if (error) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to download file',
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data.file_url;
};
//# sourceMappingURL=getAssetDownloadURL.js.map